import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import CategoryFilter from '../../common/components/categoryFilter';
import { hasCategories } from '../../common/helpers/categoryHelpers';
import FeedCard from '../../common/components/feedCard';
import DataAid from '../../common/constants/data-aids';
import Field from '../../common/constants/editable-field-tags';
import wrapWithDeviceDetection from '../../common/wrapWithDeviceDetection';

const CONTAINER_HEIGHT_CONSTANTS = {
  small: '38em',
  medium: '37em',
  large: '35em',
  xlarge: '34em'
};

class CardGroup extends Component {
  static get propTypes() {
    return {
      feeds: PropTypes.array.isRequired,
      locale: PropTypes.string,
      detachedMode: PropTypes.bool.isRequired,
      staticContent: PropTypes.object.isRequired,
      cardClickHandler: PropTypes.func,
      categoryClickHandler: PropTypes.func,
      categories: PropTypes.array,
      selectedCategory: PropTypes.string,
      imgParams: PropTypes.string,
      viewDevice: PropTypes.string.isRequired,
      device: PropTypes.string,
      fontScale: PropTypes.string
    };
  }

  getCardStyle(feed) {
    const { featuredImage } = feed;
    const desktopContainerHeight = CONTAINER_HEIGHT_CONSTANTS[this.props.fontScale] || '37em';
    const style = {
      container: {
        'display': 'flex',
        'textAlign': 'left',
        'flexDirection': 'column',
        'width': '100%',
        'height': 'auto',
        '@md': {
          height: desktopContainerHeight
        }
      },
      content: {
        // Theme
        'paddingVertical': 'large',
        'paddingHorizontal': 'medium',
        // Static
        'display': 'flex',
        'alignItems': 'left',
        'flexDirection': 'column',
        'minHeight': 'auto',
        'justifyContent': featuredImage ? 'start' : 'center',
        '@md': {
          height: '100%'
        }
      },
      background: {
        'minHeight': '200px',
        '@md': {
          minHeight: '300px'
        }
      },
      text: {
        marginBottom: 'small'
      }
    };

    return style;
  }

  render() {
    const {
      feeds,
      locale,
      detachedMode,
      staticContent,
      cardClickHandler,
      imgParams,
      viewDevice,
      categories,
      categoryClickHandler,
      selectedCategory,
      device
    } = this.props;
    const feedsToDisplay = detachedMode ? feeds.slice(0, 2) : feeds;
    const cellProps = {
      xs: '12',
      md: '6',
      pushMd: feedsToDisplay.length < 2 ? '3' : '0'
    };

    return (
      <UX2.Component.Grid data-aid={ DataAid.RSS_FEEDS_RENDERED } data-route={ Field.FEED_URL }>
        { hasCategories(categories) && (
          <UX2.Component.Grid.Cell xs='12'>
            <CategoryFilter
              categoryClickHandler={ categoryClickHandler }
              categories={ categories }
              selectedCategory={ selectedCategory }
              staticContent={ staticContent }
            />
          </UX2.Component.Grid.Cell>
        ) }
        { feedsToDisplay.map((feed, index) => (
          <UX2.Component.Grid.Cell key={ index } { ...cellProps }>
            <FeedCard
              feed={ feed }
              isCard
              locale={ locale }
              style={ this.getCardStyle(feed) }
              showContent={ true }
              staticContent={ staticContent }
              dataAid={ `${DataAid.RSS_FEED_RENDERED}_${index}` }
              cardClickHandler={ cardClickHandler }
              imgParams={ imgParams }
              viewDevice={ viewDevice }
              showCategories={ true }
              device={ device }
            />
          </UX2.Component.Grid.Cell>
        )) }
      </UX2.Component.Grid>
    );
  }
}

export default wrapWithDeviceDetection(CardGroup);
